import { useErrors } from "@auth0/auth0-acul-react/passkey-enrollment";
import { CustomOptions, ErrorItem } from "@auth0/auth0-acul-react/types";

import {
  CheckMarkShieldAccent,
  CheckMarkShieldMask,
  DeviceGlobeAccent,
  DeviceGlobeMask,
  WebAuthPlatform,
} from "@/assets/icons";
import {
  ULThemeList,
  ULThemeListDescription,
  ULThemeListItem,
  ULThemeListTitle,
} from "@/components/ULThemeList";
import { cn } from "@/lib/utils";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";

import { usePasskeyEnrollmentManager } from "../hooks/usePasskeyEnrollmentManager";

function PasskeyEnrollmentForm() {
  const { continuePasskeyEnrollment, texts, locales } =
    usePasskeyEnrollmentManager();

  const buttonText =
    texts?.createButtonText || locales.details.createPasskeyText;
  const passkeyBenefit1Title =
    texts?.passkeyBenefit1Title || locales.details.passkeyBenefit1Title;
  const passkeyBenefit1Description =
    texts?.passkeyBenefit1Description ||
    locales.details.passkeyBenefit1Description;
  const passkeyBenefit2Title =
    texts?.passkeyBenefit2Title || locales.details.passkeyBenefit2Title;
  const passkeyBenefit2Description =
    texts?.passkeyBenefit2Description ||
    locales.details.passkeyBenefit2Description;
  const passkeyBenefit3Title =
    texts?.passkeyBenefit3Title || locales.details.passkeyBenefit3Title;
  const passkeyBenefit3Description =
    texts?.passkeyBenefit3Description ||
    locales.details.passkeyBenefit3Description;

  const iconColor = extractTokenValue("--ul-theme-color-icons");

  const { errors, hasError } = useErrors();

  const generalErrors: ErrorItem[] = errors
    .byType("auth0")
    .filter((err) => !err.field);

  const onCreateClick = async (data?: CustomOptions) => {
    continuePasskeyEnrollment(data);
  };

  const renderIcon = (
    IconMask: React.ElementType,
    IconAccent?: React.ElementType,
    className?: string
  ) => (
    <div className="relative w-15 h-10 left-1.5">
      <IconMask
        className={cn("absolute inline-block opacity-[0.5]", className)}
        color={iconColor}
      />
      {IconAccent && (
        <IconAccent className="absolute inline-block" color={iconColor} />
      )}
    </div>
  );

  return (
    <div className="auth-view">
      {hasError && generalErrors.length > 0 && (
        <div className="space-y-3 mb-4">
          {generalErrors.map((error) => (
            <div className="auth-error-banner" role="alert" key={error.id}>
              {error.message || locales.errors.errorOccurred}
            </div>
          ))}
        </div>
      )}

      <ULThemeList variant="icon">
        <ULThemeListItem
          icon={renderIcon(WebAuthPlatform, undefined, "opacity-[1]")}
        >
          <ULThemeListTitle>{passkeyBenefit1Title}</ULThemeListTitle>
          <ULThemeListDescription>
            {passkeyBenefit1Description}
          </ULThemeListDescription>
        </ULThemeListItem>

        <ULThemeListItem icon={renderIcon(DeviceGlobeMask, DeviceGlobeAccent)}>
          <ULThemeListTitle>{passkeyBenefit2Title}</ULThemeListTitle>
          <ULThemeListDescription>
            {passkeyBenefit2Description}
          </ULThemeListDescription>
        </ULThemeListItem>

        <ULThemeListItem
          icon={renderIcon(CheckMarkShieldMask, CheckMarkShieldAccent)}
        >
          <ULThemeListTitle>{passkeyBenefit3Title}</ULThemeListTitle>
          <ULThemeListDescription>
            {passkeyBenefit3Description}
          </ULThemeListDescription>
        </ULThemeListItem>
      </ULThemeList>

      <div className="auth-submit-block">
        <button type="button" className="auth-btn" onClick={() => onCreateClick({ key: "passkey" })}>
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default PasskeyEnrollmentForm;
